/* eslint-disable react/no-array-index-key */
import _ from 'underscore';
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { SCREEN_BREAKPOINTS } from 'utils/helpers/constants';

import MediaRow from './components/Row';
import SvgIcons from './components/SvgIcons';
import Block from './components/Block';

import styles from './styles.module.scss';

const MediaBlock = ({
	className,
	entities,
	sectionClassName,
	titleAccent,
	showTitle,
	singleTheme
}) => {
	const [active, setActive] = useState(null);
	const [count, setCount] = useState(2);

	useEffect(() => {
		const onResize = () => {
			const desktopCount =
				entities.length > 3 ? Math.ceil(entities.length / 2) : entities.length;
			const countInRow =
				window.innerWidth >= SCREEN_BREAKPOINTS.mobileLarge ? desktopCount : 2;

			setCount(countInRow);
		};

		onResize();

		window.addEventListener('resize', onResize);

		return () => {
			window.removeEventListener('resize', onResize);
		};
	}, [entities.length]);

	useEffect(() => {
		setActive(null);
	}, [entities]);

	const handleClick = useCallback((type) => {
		setActive((currentActive) => (currentActive === type ? null : type));
	}, []);

	const blockTitleCx = cx(
		styles.MediaBlockTitle,
		{
			[styles.MediaBlockTitle_accent]: titleAccent
		},
		sectionClassName
	);
	const wrapSingleCx = cx(
		singleTheme && styles[`MediaBlock__WrapSingle_theme_${singleTheme}`]
	);

	return (
		<div className={cx(styles.MediaBlock, className)}>
			{entities.length > 1 ? (
				_(entities)
					.chunk(count)
					.map((rowEntities, index) => (
						<MediaRow
							key={`index-${index}-count-${rowEntities.length}`}
							className={styles.MediaBlockRow}
							blockClassName={styles.MediaBlockSlider}
							containerClassName={styles.MediaBlockContainer}
							activeType={active}
							entities={rowEntities}
							onClick={handleClick}
							theme={index % 2 ? null : 'revert'}
						/>
					))
			) : (
				<div className={wrapSingleCx}>
					{showTitle ? (
						<div className={blockTitleCx}>{entities[0].title}</div>
					) : null}
					<Block {...entities[0]} containerClassName={sectionClassName} />
				</div>
			)}
			<SvgIcons />
		</div>
	);
};

MediaBlock.propTypes = {
	entities: PropTypes.array.isRequired,
	className: PropTypes.string,
	sectionClassName: PropTypes.string,
	titleAccent: PropTypes.bool,
	showTitle: PropTypes.bool,
	singleTheme: PropTypes.oneOf(['dark'])
};

MediaBlock.defaultProps = {
	showTitle: true
};

export default MediaBlock;
